import { Color } from 'pixi.js';
import type { TileColorMap } from '../boardMVC/TileColor';
import { TileColor } from '../boardMVC/TileColor';

export const SCORE_COLOR_MAP: TileColorMap<{ text: Color; stroke: Color }> = {
  [TileColor.None]: { text: new Color('#000000'), stroke: new Color('#000000') },
  [TileColor.Red]: { text: new Color('#ff2618'), stroke: new Color('#7a0014') },
  [TileColor.Green]: { text: new Color('#14fe00'), stroke: new Color('#006313') },
  [TileColor.Blue]: { text: new Color('#2bd7ff'), stroke: new Color('#004eb9') },
  [TileColor.Pink]: { text: new Color('#ff48ce'), stroke: new Color('#730054') },
  [TileColor.Yellow]: { text: new Color('#ffe328'), stroke: new Color('#e46b00') },
  [TileColor.Grey]: { text: new Color('#6c6c6c'), stroke: new Color('#292929') },
  [TileColor.White]: { text: new Color('#f7f7f7'), stroke: new Color('#6d6d6d') },
  [TileColor.Navy]: { text: new Color('#0d5cff'), stroke: new Color('#0011af') },
  [TileColor.Purple]: { text: new Color('#b120ff'), stroke: new Color('#5700b1') },
};

export const GOAL_SCORE_COLORS = {
  text: new Color('#f7f7f7'),
  stroke: new Color('#870066'),
};
